import React from 'react'
import styles from './Contact.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'

export default function Contact() {
  return (
    <div id={styles.contact}>
      <div id={styles.contactContainer}>
        <h2>Where to find me?</h2> 
        <div id={styles.logoContainer}>
          <a href="https://github.com/Tendaik96">
            <FontAwesomeIcon icon={faGithub} className={styles.icon} />
            <label>GitHub</label>
          </a>

          <a href="https://www.linkedin.com/in/tendai-karuwo/">
            <FontAwesomeIcon icon={faLinkedin} className={styles.icon} />
            <label>LinkedIn</label>
          </a>

          <a href="mailto:tendaikaruwo96@gmail.com">
            <FontAwesomeIcon icon={faEnvelope} className={styles.icon} />
            <label>Email</label>
          </a>
        </div>
      </div>
      
      
    </div>
  )
}
